import { Theme } from './types';

export const lsPrefix = 'burdukowsky/cv/';
export const lsThemeKey = 'theme';
export const defaultTheme: Theme = 'default';
